
const cn = {
    logo: '春梅信息',
    // 导航
    menu: {
        
        home: '首页',

        // 档案管理
        constructionMana: '档案管理',
        addConstruction: '●  楼宇管理',
        meterBinding: '●  表计绑定',
        choseMeter: '选择表计',
        householdMana: '●  业主管理',
        addHousehold: '添加业主',
		balanceChange: '流水查询',

        // 设备管理
        equipmentMana: '设备管理',
        gatewayMana: '●  集控器管理',
		directlyMana:'●  直连设备管理',
        plateMana: '●  设备状态',
        addMeter: '添加表计',
        equipmentControl: '●  设备控制',
        equipmentControlInfo: '设备详情页',
        terminalcontrollist: '●  设备监控',
        terminalcontrolset: '设备监控设置',
        devicefault: '●  设备故障',

        // 收费管理
        systemSetting: '收费管理',
        readingmeter: '●  抄读结算',
        ownerclose: '业主结算',
        chargeprint: '●  费用打印',

        priceSetting: '价格设置',
        billSetting: '表头设置',
        printpreview: '打印预览',

        // 报表管理
        setteleMana: '报表管理',
        residentDosage: '●  用量报表',
        receivablestatement: '●  应收报表',
        paystatement: '●  缴费报表',
		historyreport:'表计历史数据',

        dosage: '用量汇总报表',
        receivable: '应收汇总报表',
        userPay: '用户缴费查询',
        residentBill: '业主账单报表',
        userEquipment: '用户设备清单',
        userDetail: '用户详细用量',
        defindBill: '自主账单报表',

        // 抄控管理
        chaokongMana: '抄控管理',
        equipmentGroup: '●  设备分组',
        addEquipment: '添加设备',
        alarmset: '报警设置',
        clustermana: '●  群控管理',
        timing: '●  定时管理',
        addTiming: '添加定时',
        arrearagemana: '欠费管理',
        running: '运行状态',
        billingmode: '计费模式',

        // 系统管理
        roleSetting: '系统管理',
        role: '●  账号管理',
        authority: '●  权限控制',
        logmanage: '●  日志管理',
		aftersales: '●  售后服务',

        //  计费方案
        chargescheme: '●  计费方案',
        setCharge: '计费设置',
        setPrice: '价格设置',
        arrearageset: '欠费设置',

        // 个人中心
        userCenter: '个人中心',
		userEmail:'●  绑定邮箱',
        personalsetting: '个人设置',
        messageCenter: '●  消息中心',
        changePassword: '●  修改密码',
		headchangePassword: '修改密码',
        // 超级管理
        admin: '基础配置管理',
        projecttypesetting: '项目类型',
        chargeschemelist: '计费方案',
        addchargescheme: '添加计费方案',
        companyMana: '账号管理',
        roleModule: '权限模块',
        dictionary: '字典配置',
        sysdic: '系统配置',

        // 机房系统
        machinemana: '机房监控',
        machineDeviceStatus: '设备工况',
        faultlist: "故障记录",
        deviceCurve: "数据曲线",
        deviceReport: "数据报表",
		deviceReportsetting: "●  数据报表配置",
        timerMana: "定时管理",
        setTiming: '添加定时',
        argSetting: "参数设置",
        advanceArgsetting: "●  高级参数设置",
        frequencysetting: "●  频率设置",
        pressuresetting: "●  压力设置",
        delayedsetting: "●  延时设置",
        tempsetting: "●  温度设置",
        variableset: "变量设置",
        plcterminal: '设备配置',
        argmana: "●  变量管理",
        serverroom: "页面配置",
        log: "●  日志管理",
        mobileMonitoring: "移动端监控设置",
        pumpsetting: '水泵参数设置',
        basesetting: '基础配置',
        energybase: '●  节能基数配置',
        EnergySituation: '节能概况',
		EnergySituationset: '●  节能概况',
        EnergySystem: '●  系统节能',
        EnergySystemDay: '系统节能日报',
        EnergyPump: '●  水泵节能',
        EnergyPumpList: '●  水泵节能列表',
        EnergyPumpDetail: '水泵节能明细',
        EnergyPumpDay: '水泵节能日报'
    },
    // 头部
    header: {
        userCenter: '用户中心',
        logout: '退出系统',
    },
    project: {
        unInputProject: '请输项目名称',
		unInputpropriname:'请输入项目负责人',
		unInputpropritel:'请输入项目负责人电话',
		unInputperpriname:'请输入物业负责人',
		unInputperpritel:'请输入物业负责人电话',
		unInputProjectSystem: '请输入系统名称',
        unInputProperty: '请输入物业名称',
        unInputTelphone: '请输入电话号码',
        unInputSalename: '请输入经销商/业务员名称',
        unInputProjectType: '请选择项目类型',
        unInputChargeScheme: '请选择计费方案',
        unInputRegions: '请选择所属地区',
        unInputAddress: "请输入详细地址",
        addProject: '新增项目',
		addProjectSystem: '新增项目系统',
		systemName: '系统名称',
        proName: '项目名称',
		propriname:'项目负责人',
		propritel:'项目负责人电话',
		perpriname:'物业负责人',
		perpritel:'物业负责人电话',
        systemType: '系统类型',
        propertyName: '物业名称',
        salename: '	经销商/业务员',
        telphone: '电话',
        remark: '备注',
        createSuccess: '创建成功',
        createProject: '创建项目',
		createProjectsystem: '创建系统',
        projectType: '建筑类型',
        chargescheme: '计费方案',
        regions: '所属地区',
        address: "详细地址",
        operation: '操作',
        province: "请选择省",
        city: "请选择市",
        country: "请选择区"

    },
    // 表计统计页面
    meter: {
        bindMeter: '绑定表计',
        residenceNum: '住宅编号',
        meterType: '表计类型',
        meterNum: '表计表号',
        meterModel: '表计型号',
        gatewayNum: '网关编号',
        fancoilModel: '风盘型号',
        bindAddress: '安装位置',
        compoundTable: '复合表',
        autoMeterNum: '自定义表号',
        metrology: '计量式',
        meterInfo: '表计信息',
    },
    login: {
        title: '春梅信息管理平台',
        loginbBtn: '登录',
        username: '用户名/手机号码',
        password: '密码',
        unInputUserError: '请输入用户名',
        unInputPwdError: '请输入密码',
        userLoginError: '用户名或密码错误',
        loginFailing: '登录失败',
        invaildUser: '用户名不存在',
        phoneBind: '绑定手机号码',
        telephone: '手机号码',
        unInputPhone: '请输入手机号码',
        errorPhone: '无效的手机号码',
        unInputCode:'请输入验证码',
        getCode: '获取验证码',
        codeError: '验证码错误'
    },
    residence: {
        'name': '名称',
        'remark': '备注',
        'ide': '编号',
        'roomArea': '房屋面积'
    },
    household: {
        baseInfo:'基本信息',
        payInfo: '支付信息',
        deviceInfo: '表计信息',
        resiNum: '住宅编号',
        holdNum: '业主编号',
        holdStatus: '业主状态',
        holdName: '业主名称',
        unitPriceType: '单价类型',
        expenseType: '计费类型',
        discount: '折扣率',
        sex: '性别',
        telephone: '手机号码',
        remain: '业主余额',
        payType: '支付类型',
        depositBank: '开户银行',
        depositNum: '开户卡号',
        deviceStatus: '设备状态',
        payNum: '支付账号',
        IDCard: '证件类型',
        IDNum: '证件号码',
        email: '电子邮箱',
        selectRes: '住宅选择',
        holdTotal: '业主总数',
        holdNormal: '正常业主',
        holdCancel: '已销户',
        resAddress: '住宅地址',
        empty: '清空',
        addHold: '添加业主',
        emptyHoldName: '请输入业主名称',
        emptyIDCard: '请选择证件类型',
        emptyIDNum: '请输入证件号码',
        emptyTele: '请输入手机号码',
        emptyPayType: '请选择支付类型',
        emptyDepBank: '请输入开户银行',
        emptyPayNum: '请输入支付账号',
        emptyUPType: '请选择单价类型',
        emptyDiscount: '请选择折扣率',
        emptyDevStatus: '请选择设备状态',
        emptyResidence: '请选择住宅',
        errorEmail: '无效的邮箱',
        errorResidence: '请选择至最后级别'
    },
    btns: {
		map:'地图',
		list:'列表',
        sure: '确定',
        search: '查询',
        save: '保存',
        edit: '编辑',
        delete: '删除',
        add: '添加',
        exports: '导出',
        cancel: '取消',
        batchAdd: '批量添加',
        singleAdd: '单个添加',
        see: '查看',
        keyword: '关键字',
        verify: '修改',
        operate: '操作',
        sureAdd: '确定并添加',
        sureSave: '确定并保存',
        cancelHold: '销户'
    },
    time: {
        second: '秒'
    },
    message: {
        tips: '提示',
        reLogin: '重新登录',
        reLoginTip: '该账号在其他地方登录，须重新登录',
        number: '数量',
        isDelLeaf: '是否确认删除{msg}?',
        deleSuccess: '删除成功',
        verifySuccess: '修改成功',
        createSuccess: '创建成功',
        unInputName: '请输入名称',
        pSelect: '请选择',
        goAdd: '继续添加',
        backHoldList: '返回业主列表',
        addHoldSuccess:'业主添加成功',
        verifyHoldSuccess:'业主修改成功'
    },
    globalCode: {
        20001000: '成功',
        20001001: '',
        20001002: '登录过期',

        30001001: '请求参数错误',
        30001002: '无效信息',
        30001003: '无效信息',

        40001001: '未经许可',
        40001002: '禁止设备访问',
        40001003: '禁止模块访问',
        40001004: '禁止项目访问',
        40001005: '禁止访问操作',
        40001006: '不良用户凭证',

        40011001: '未发现',
        40011002: '用户已存在',

        50001001: '网络错误',
        50001002: '数据库出错',
        50001003: '服务器错误'
    },
    lang: '语言'
}
export default cn